import React from 'react'
import { Container } from 'react-bootstrap'
import vision from '../Assets/Images/vision.jpeg'
import { motion } from 'framer-motion'
import data from '../Assets/Datas/mission'
import { Helmet } from 'react-helmet-async'
const Mission = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div>
      <Helmet>
        <title>Vision & Mission</title>
        <meta
          name="description"
          content="At Oyoyo, our mission is to consistently enhance the quality of our products and services while boosting the productivity of the communities we serve."
        />
        <link rel="canonical" href="https://oyoyolubricant.com/company/vision-mission" />
      </Helmet>
      <div className="bg-accent1 py-2 text-sm text-slate-500 underline cursor-pointer">
        <Container>
          <p>Oyoyo Lubricants &rarr; Vision & Mission</p>
        </Container>
      </div>
      <div>
        <Container className="p-3 mb-8 px-4">
          <div className="relative h-48 md:h-72 w-full mb-8">
            <div
              className="h-full w-full rounded-lg shadow-lg"
              style={{
                backgroundImage: `url(${vision})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                <h2 className='text-2xl md:text-4xl font-semibold text-white uppercase tracking-wider'>Vision & Mission</h2>
              </div>
            </div>
          </div>
          <div>
            {data.map((item, index) => (
              <motion.div
                key={index}
                className={`bg-yellow-300 flex flex-col  md:flex-row ${index % 2 === 1 ? 'md:flex-row-reverse' : ''} items-center justify-center`}
                variants={itemVariants}
              >
                <div className="w-full md:w-1/2 h-120 overflow-hidden">
                  <motion.img
                    src={item.img}
                    alt={`Image ${index + 1}`}
                    className={`w-full h-full object-cover ${item.top}`}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  />
                </div>
                <div className="w-full md:w-1/2 flex flex-col items-center text-center justify-between md:mt-0 md:px-4 text-black ">
                  <div>
                    <motion.h3
                      className="text-2xl md:text-3xl font-semibold mt-4 tracking-wider mb-3 subpixel-antialiased"
                      variants={itemVariants}
                    >
                      {item.header}
                    </motion.h3>
                    <motion.p className="text-base" variants={itemVariants}>
                      {item.text}
                    </motion.p>
                  </div>
                  <motion.button
                    className="text-sm font-medium text-yellow-600 capitalize mt-4"
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                  >
                    {item.btnText}
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Mission
